import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3000/api';

export interface PublicCompany {
  cnpj?: string;
  razaoSocial?: string;
  slug?: string;
  // logoPath removido por segurança
  logoUrl?: string;
  whatsappPhone?: string;
  message?: string;
  active: boolean;
  isOpen?: boolean;
  // modules simplificado para campos booleanos seguros
  hasPayments?: boolean;
  hasInventory?: boolean;
  // plan removido por segurança
  updatedAt?: string;
}

export async function fetchCompanyByCnpj(cnpj: string): Promise<PublicCompany | null> {
  try {
    const response = await axios.get<PublicCompany>(`${API_URL}/companies`, {
      params: { cnpj },
    });
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error('Erro ao buscar dados da empresa:', error);
    throw error;
  }
}

export async function fetchCompanyByIdentifier(identifier: string): Promise<PublicCompany | null> {
  try {
    const response = await axios.get<PublicCompany>(`${API_URL}/companies/${identifier}`);
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error('Erro ao buscar dados da empresa:', error);
    throw error;
  }
}
